import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo2_Nuno } from '../../../../../utils/ES/Modals/directors';

const ModalVideoNuno2 = () => {
  return (
    <>
      <ModalVideo
        id="nuno-video-2"
        dataText={TextVideo2_Nuno}
        videoSrc="https://player.vimeo.com/video/871689495?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_NUNO_2"
      />
    </>
  );
};

export default ModalVideoNuno2;
